import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { message, Upload } from "antd";
import { UploadChangeParam } from "antd/lib/upload";
import dayjs from "utils/dayjs";
import React, { useEffect, useRef, useState } from "react";
import { getToken } from "utils/auth";
import { $url } from "utils/url";

interface SingleImageUploadProps {
  uploadUrl?: string;
  imageUrl: string;
  onUploadOk: (path: string) => void;
  width?: number | string;
  height?: number | string;
  disabled?: boolean;
}

export const SingleImageUpload = React.memo(
  ({
    uploadUrl = import.meta.env.VITE_API_URL + "/v1/shop/staff/upload",
    imageUrl,
    onUploadOk,
    height = 150,
    width = 150,
    disabled,
  }: SingleImageUploadProps) => {
    const [loading, setLoading] = useState(false);
    const uploadRef = useRef(null);
    const [singleUploadId, setsingleUploadId] = useState(
      `single-upload-${dayjs().valueOf()}`,
    );

    const beforeUpload = (file: File) => {
      const isImg = file.type.includes("image");
      if (!isImg) {
        message.error("Only accept image format");
      }

      return isImg;
    };
    const handleChange = (info: UploadChangeParam<any>) => {
      if (info.file.status === "uploading") {
        setLoading(true);
        return;
      }
      if (info.file.status === "done") {
        onUploadOk(import.meta.env.VITE_API_URL + info.file.response.data.path);
        setLoading(false);
      }
    };

    const uploadButton = (
      <div>
        {loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );

    useEffect(() => {
      const container = document.querySelector<HTMLDivElement>(
        `.${singleUploadId} .ant-upload-select`,
      );
      if (container) {
        container.style.width = typeof width == "number" ? `${width}px` : width;
        container.style.height =
          typeof height == "number" ? `${height}px` : height;
      }
    }, []);

    return (
      <Upload
        name="file"
        listType="picture-card"
        className={singleUploadId}
        showUploadList={false}
        action={uploadUrl}
        headers={{
          token: getToken() || "",
        }}
        beforeUpload={beforeUpload}
        onChange={handleChange}
        ref={uploadRef}
        disabled={disabled}
        style={{
          width: 200,
        }}
      >
        {imageUrl ? (
          <img
            src={$url(imageUrl)}
            alt="avatar"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        ) : (
          uploadButton
        )}
      </Upload>
    );
  },
);
